import React from "react";
import { Modal } from "sprint-common-web";

import { RejectOrderForm } from "./RejectOrderForm";

export interface RejectOrderModalProps {
    orderId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const RejectOrderModal: React.VFC<RejectOrderModalProps> = ({
    orderId,
    onCancel,
    onSubmit,
    isOpen
}: RejectOrderModalProps) => {
    return (
        <Modal headerText="Reject" onDismiss={onCancel} isBlocking={true} isOpen={isOpen}>
            <RejectOrderForm orderId={orderId} onCancel={onCancel} onSubmit={onSubmit} />
        </Modal>
    );
};
